export default __webpack_public_path__ + "img/0f7c584b427dc9c66afacf54507a7d01.png";